//sessionStorage
export enum SessionStorage {
  Service = 'service',
  Shuttle = 'shuttle',
  Filters = 'filters',
  OrderPageState = 'orderPageState',
}

//localStorage
export enum LocalStorage {
  Token = 'token',
  Client = 'client',
  Supplier = 'supplier',
}